// src/redux/sentiment/sentimentActionThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import SentimentAPI from "./sentimentAggAPI";

// Fetch sentiment for a stock
export const fetchStockSentimentAggsThunk = createAsyncThunk(
  "sentiment/fetchAggs",
  async ({ ticker, timeframe = "all" }, { rejectWithValue }) => {
    const normalizedTicker =
      typeof ticker === "string" ? ticker.trim().toUpperCase() : null;

    // Canonical validation: sentiment requires a real ticker
    if (!normalizedTicker || normalizedTicker === "--") {
      return rejectWithValue("Invalid ticker for sentiment fetch");
    }

    try {
      return await SentimentAPI.fetchStockSentiment(
        normalizedTicker,
        timeframe
      );
    } catch (err) {
      return rejectWithValue(
        err?.message || "Failed to fetch sentiment"
      );
    }
  }
);

// Batched sibling -- fetches sentiment for many tickers in one HTTP request.
// See Technical_Docs/13_FIX_HISTORY.md's seventy-second pass.
export const fetchStockSentimentAggsBatchThunk = createAsyncThunk(
  "sentiment/fetchAggsBatch",
  async ({ tickers, timeframe = "all" }, { rejectWithValue }) => {
    const normalizedTickers = (tickers || [])
      .map((t) => (typeof t === "string" ? t.trim().toUpperCase() : null))
      .filter((t) => t && t !== "--");

    if (!normalizedTickers.length) {
      return rejectWithValue("No valid tickers for batch sentiment fetch");
    }

    try {
      return await SentimentAPI.fetchStockSentimentBatch(
        normalizedTickers,
        timeframe
      );
    } catch (err) {
      return rejectWithValue(
        err?.message || "Failed to fetch batch sentiment"
      );
    }
  }
);
